"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelGroupsLoader = void 0;
const consts_1 = require("@opsbase/lib-data-query/consts");
const QueryFieldKey_1 = __importDefault(require("@opsbase/lib-data-queryfield/QueryFieldKey"));
const NotSpecified_1 = require("@opsbase/lib-general/NotSpecified");
const useSelf_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelf"));
const useDataSearch_1 = __importDefault(require("@opsbase/react-gql-datasearch/useDataSearch"));
const useView_1 = __importDefault(require("@opsbase/web-ctrl-view/useView"));
const react_1 = require("react");
const useDataTree_1 = __importDefault(require("../../useDataTree"));
const useDataTreeActions_1 = __importDefault(require("../../useDataTreeActions"));
function ModelGroupsLoader(props) {
    const { groupBy } = props;
    const { viewId } = (0, useDataTree_1.default)();
    const { setGroupCollectionForGroupBy } = (0, useDataTreeActions_1.default)();
    const view = (0, useView_1.default)(viewId);
    const { filters, reportPage } = view;
    const self = (0, useSelf_1.default)();
    // If we're XQueryFilter by items in the group, we simply return with those
    // Otherwise, we search using the REPORT PAGE
    const groupIds = filters
        .filter(fb => fb.queryFieldKey === groupBy.queryFieldKey)
        .map(fb => fb.id);
    const variables = !!groupIds.length
        ? {
            id: groupIds,
        }
        : {
            offset: reportPage * consts_1.GroupPageSize,
            limit: consts_1.GroupPageSize,
        };
    const { loading, data } = (0, useDataSearch_1.default)(groupBy.queryFieldKey, variables);
    (0, react_1.useEffect)(() => {
        let groups = undefined;
        let totalCount = undefined;
        if (data) {
            // Add Loaded Items
            groups = data.items.map(({ id, title }) => (Object.assign(Object.assign({}, groupBy), { id,
                title })));
            totalCount = data.totalCount;
            // Add not specified
            let disableNotSpecifiedGroup = reportPage > 0;
            if (!(disableNotSpecifiedGroup ||
                (!self.accessiblePlaces.all && groupBy.queryFieldKey === QueryFieldKey_1.default.PLACE) ||
                (!self.accessiblePositions.all &&
                    groupBy.queryFieldKey === QueryFieldKey_1.default.POSITION) ||
                (!self.accessibleTeams.all && groupBy.queryFieldKey === QueryFieldKey_1.default.TEAM))) {
                groups.push(Object.assign(Object.assign({}, groupBy), { id: NotSpecified_1.NOTSPECIFIED, title: 'Not specified' }));
            }
        }
        setGroupCollectionForGroupBy(groupBy, {
            loading,
            lastLoaded: new Date(),
            totalCount,
            groups,
        });
    }, [loading, data, groupBy, reportPage, self, setGroupCollectionForGroupBy]);
    return null;
}
exports.ModelGroupsLoader = ModelGroupsLoader;
exports.default = ModelGroupsLoader;
